import script from "./FileSizeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileSizeModal.vue?vue&type=script&setup=true&lang=ts"

import "./FileSizeModal.vue?vue&type=style&index=0&id=3b5647b2&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b5647b2"]])

export default __exports__